var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path !== '/')?_c('nav-header'):_vm._e(),_c('router-view'),(_vm.$route.path !== '/')?_c('app-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }